<template>
	<v-dialog
    persistent
    width="400"
    v-model="avatarParamentro.editar"
  >
    <v-card style="border-radius: 0px;">
      <v-card-title class="text-h5">
      </v-card-title>
      <v-card-text>
      	<div v-if="!file">
          <div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
            <div class="dropZone-info" @drag="onChange">
              <span class="fa fa-cloud-upload dropZone-title"></span>
              <span class="dropZone-title blue--text"><b>Arrastre el archivo para cargar</b></span>
              <div class="dropZone-upload-limit-info">
                <div>Extensión: png, jpg, jpeg, svg</div>
                <div>Tamaño máximo: 10 MB</div>
              </div>
            </div>
            <input type="file" @change="onChange">
          </div>
        </div>
        <v-btn  v-else color="red" class="mb-2" dense @click="removeFile" fab small dark><v-icon>mdi-delete</v-icon></v-btn>
        <v-img :src="vistaPrevia.url" v-if="vistaPrevia" contain max-height="300"/>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="black"
          tile
          dark
          small
          @click="avatarParamentro.editar = false"
        >
        	<v-icon small left>mdi-cancel</v-icon>
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          tile
          dark
          small
          @click="grabarImagen()"
        >
        	<v-icon small left>mdi-content-save</v-icon>
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>

    
    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';
	import Avataaars from 'vuejs-avataaars'
	import { mapActions, mapGetters } from 'vuex'
	// Dependencias
  const md5     = require('md5')

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  export default {
  	props:[
			'avatarParamentro'
	  ],

  	components:{
  		Alerta,
  		Avataaars,
  		carga
  	},

  	mixins: [ validarErrores, funcionesExcel ],
  	
    data: () => ({

    	 // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

	    dialogEditAvatar: false,

			avatar: {
				isCircle: true,
	      accessoriesType:null,
	      clotheType:null,
	      clotheColor:null,
	      eyebrowType: null,
	      eyeType: null,
	      facialHairColor:null,
	      facialHairType:null,
	      graphicType: null,
	      hairColor:null,
	      mouthType:null,
	      skinColor:null,
	      topType:null,
	      topColor:null,
	      circleColor:'#6fb8e0'
			},

			respuestaAlerta: false,
      loader: true,
      cargar: false,
			parametros:{
      	dialogError: false,
      	mensaje: '',
      	color: ''
     	},

     	file: '',
      dragging: false,
      archivos:null,
      vistaPrevia: null,

    }),

    computed:{
    	...mapGetters( 'login', [ 'getdatosUsuarioFitHouse', 'getAvatar']),
    },

    created () {

    	console.log( this.getdatosUsuarioFitHouse )
    	if( this.getdatosUsuarioFitHouse.foto ){
    		this.avatar = this.getAvatar
    	}
    },

    methods: {
    	...mapActions( 'login', [ 'grabarUsuario', 'guardarInfo', 'grabarAvatar' ]),

    	habilitarVentana ( ventana ){
    		this.ventana = ventana
    	},

      validarDatos () {
        return this.$refs.form.validate()
      },

      grabarImagen( ){
      	this.cargar = true
        let formData = new FormData();
        //se crea el objeto y se le agrega como un apendice el archivo
        formData.append("file"      , this.file);
        formData.append("idusuarios", this.getdatosUsuarioFitHouse.idusuarios );

        this.$http.post("grabar.avatar", formData).then( response => {
      		this.cargar = false
      		this.removeFile()

      		this.getdatosUsuarioFitHouse.foto = response.body.nombre
      		this.guardarInfo( this.getdatosUsuarioFitHouse )
      		this.avatarParamentro.editar = false
          console.log( response )
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

			getBase64(file) {
	      var me = this
	      var reader = new FileReader();
	      reader.readAsDataURL(file);
	      reader.onload = function () {
	        me.vistaPrevia = {
	          url: reader.result, 
	          image_name: file.name
	        }
	      };
	    },

			onChange(e) {
	      var files = e.target.files || e.dataTransfer.files;
	      
	      if (!files.length) {
	        this.dragging = false;
	        return;
	      }
	      
	      this.createFile(files[0]);
	    },

	    createFile(file) {
	      if (!file.type.match('image.*')) {
	        alert('please select txt file');
	        this.dragging = false;
	        return;
	      }
	      
	      if (file.size > 10000000) {
	        alert('please check file size no over 5 MB.')
	        this.dragging = false;
	        return;
	      }
	      
	      this.file = file;
	      this.archivos = file;
	      this.getBase64(this.archivos)
	      this.dragging = false;
	    },

	    removeFile() {
	      this.vistaPrevia        = null
	      this.archivos           = null
	      this.file               = '';
	    },
    },
  }
</script>
<style scoped>
  .dropZone {
    width: 100%;
    height: 150px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone:hover {
    border: 2px solid #D8D8D8;
  }

  .dropZone:hover .dropZone-title {
    color: #1975A0;
  }

  .dropZone-info {
    color: #A8A8A8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  ..dropZone-title {
    color: #787878;
  }

  .dropZone input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .dropZone-upload-limit-info {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
  }

  .dropZone-over {
    background: #D8D8D8;
    opacity: 0.8;
  }

  .dropZone-uploaded {
    width: 80%;
    height: 200px;
    position: relative;
    border: 2px dashed #eee;
  }

  .dropZone-uploaded-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #D8D8D8;
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
  }

  .removeFile {
    width: 200px;
  }
</style>